import React from "react";
import EquipmentPanel from "./EquipmentPanel";
import { useExecution } from "./executionContext";
import IncrementDialog from "./IncrementDialog";

/** DBCO-0048 - mounted in the page's `executionSection` slot: shows the panel or dialog the row actions opened. */
const ExecutionDialogs: React.FC<{ operationId: string }> = ({ operationId }) => {
  const { active, close } = useExecution();
  if (!active) {
    return null;
  }
  const key = `${active.kind}-${active.sequence.id}`;
  return active.kind === "equipment" ? (
    <EquipmentPanel
      key={key}
      operationId={operationId}
      sequence={active.sequence}
      onClose={close}
    />
  ) : (
    <IncrementDialog key={key} operationId={operationId} execution={active} onClose={close} />
  );
};

export default ExecutionDialogs;
